import { OPEN_LINKAGES_BY_ID } from './constants'

export const openLinkagesById = (id) => ({
    type: OPEN_LINKAGES_BY_ID,
    data: { id },
})
